import { TuneOutlined } from "@mui/icons-material";
import { Box, CircularProgress, FormControlLabel, Switch, Typography } from "@mui/material";
import { useState } from "react";
import { SecaoConfiguracao } from "../../../../../core/components/SecaoConfiguracao";
import { useMarketplaces } from "../../../../hooks/useMarketplaces";
import { IConfiguracaoMesaMarketplace } from "../../../../interfaces/IConfiguracaoMesaMarketplace";
import { IMarketplace } from "../../../../interfaces/IMarketplace";

interface ConfiguracaoMesaPaperProps {
    marketplace: IMarketplace;
    refresh: () => void;
}

type ChaveRegraMesa = "aberturaAutomatica" | "exibirItensParticipantes" | "permitirPedirConta";

const regras: { chave: ChaveRegraMesa, titulo: string, descricao: string }[] = [
    {
        chave: "aberturaAutomatica",
        titulo: "Abrir a mesa pelo QR Code",
        descricao: "Desligado, o atendente precisa abrir a mesa no PDV antes do primeiro pedido.",
    },
    {
        chave: "exibirItensParticipantes",
        titulo: "Mostrar os pedidos de todos da mesa",
        descricao: "Desligado, cada pessoa vê só o que pediu. O total da mesa continua visível.",
    },
    {
        chave: "permitirPedirConta",
        titulo: "Pedir a conta pelo QR Code",
        descricao: "Qualquer pessoa da mesa pode pedir a conta; novos pedidos ficam bloqueados até o atendente reabrir.",
    },
];

export const ConfiguracaoMesaPaper = ({ marketplace, refresh }: ConfiguracaoMesaPaperProps) => {
    const { salvar } = useMarketplaces();
    const [salvando, setSalvando] = useState<ChaveRegraMesa>();
    const mesa: IConfiguracaoMesaMarketplace = marketplace.configuracao?.mesa ?? {};

    const alterar = async (chave: ChaveRegraMesa, valor: boolean) => {
        setSalvando(chave);
        await salvar({
            ...marketplace,
            configuracao: {
                ...marketplace.configuracao,
                mesa: { ...mesa, [chave]: valor },
            },
        });
        setSalvando(undefined);
        refresh();
    };

    return (
        <SecaoConfiguracao
            titulo="Regras da mesa"
            descricao="Como os clientes usam o QR Code na mesa"
            icone={<TuneOutlined />}
        >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {regras.map(regra => (
                    <Box key={regra.chave} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
                        <Box>
                            <Typography variant="body2" fontWeight={600}>{regra.titulo}</Typography>
                            <Typography variant="caption" color="text.secondary">{regra.descricao}</Typography>
                        </Box>
                        {salvando === regra.chave ? (
                            <CircularProgress size={24} />
                        ) : (
                            <FormControlLabel
                                label=""
                                sx={{ m: 0 }}
                                control={
                                    <Switch
                                        checked={mesa[regra.chave] !== false}
                                        onChange={(_, valor) => alterar(regra.chave, valor)}
                                        disabled={!!salvando}
                                    />
                                }
                            />
                        )}
                    </Box>
                ))}
                <Typography variant="caption" color="text.secondary">
                    Os pedidos enviados pelo QR Code seguem o fluxo de operação de Mesa: no fluxo completo cada envio
                    aguarda confirmação no salão; no fluxo PDV vai direto para a cozinha. A comanda de acréscimo
                    imprime automaticamente quando este marketplace estiver selecionado na configuração da comanda.
                </Typography>
            </Box>
        </SecaoConfiguracao>
    );
};
